import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import { makeStyles } from "@material-ui/core";
import get from "lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

export default function AccountSummary() {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const [showHide, setShowHide] = useState(true);
	const [accountSummaryData, setAccountSummaryData] = useState([]);

	useEffect(() => {
		getData();
	}, []);

	const getData = async () => {
		setLoading(true);
		try {
			await get(`/api/accountsummary`, true)
				.then((res) => {
					if (res.data.success) {
						setAccountSummaryData(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Account Summary", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Account Summary", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Account Summary", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	return (
		<div className={classesCSStyles.mx5}>
			<Card className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
				<CardHeader color="info" className="">
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<h4 className={classesCSStyles?.cartLabel}>Account Summary</h4>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classesCSStyles.alignRight}>
							<div className={classesCSStyles?.editBtns}>
								<div
									onClick={() => {
										setShowHide(!showHide);
									}}
									className={classNames(classesCSStyles.editBtn)}>
									{showHide ? "HIDE" : "SHOW"}
								</div>
							</div>
						</GridItem>
					</GridContainer>
				</CardHeader>
				<CardBody
					className={classNames(
						classesCSStyles.accountSection,
						classesCSStyles.my10
					)}>
					{showHide && (
						<>
							{loading && (
								<Loading
									width={30}
									height={30}
									className={classesCSStyles.absoluteLoading}
								/>
							)}
							<GridContainer className={classNames(classesCSStyles.marginAuto)}>
								<GridItem
									xs={12}
									sm={12}
									md={12}
									className={classNames(loading ? classesCSStyles.loading : "")}>
									<GridContainer className={classNames(classesCSStyles.marginAuto)}>
										<GridItem xs={12} sm={2} md={2}>
											<div className={classesCSStyles?.accountSummaryLabel}>
												Credit Limits
											</div>
											<div className={classesCSStyles?.accountSummarySubLabel}>
												{accountSummaryData?.creditLimit}
											</div>
										</GridItem>
										<GridItem xs={12} sm={2} md={2}>
											<div className={classesCSStyles?.accountSummaryOverLabel}>Terms</div>
											<div className={classesCSStyles?.accountSummarySubLabelOverdue}>
												{accountSummaryData?.terms}
											</div>
										</GridItem>
										<GridItem xs={12} sm={2} md={2}>
											<div className={classesCSStyles?.accountSummaryLabel}>
												Available Credit
											</div>
											<div className={classesCSStyles?.accountSummarySubLabel}>
												{accountSummaryData?.creditAvailable}
											</div>
										</GridItem>
									</GridContainer>
									<GridContainer className={classNames(classesCSStyles.marginAuto)}>
										<GridItem xs={12} sm={2} md={2}>
											<div className={classesCSStyles?.accountSummaryLabel}>
												Total Balance
											</div>
											<div className={classesCSStyles?.accountSummarySubLabel}>
												{accountSummaryData?.balance}
											</div>
										</GridItem>
										<GridItem xs={12} sm={2} md={2}>
											<div className={classesCSStyles?.accountSummaryOverLabel}>
												More than 30 Days
											</div>
											<div
												className={classNames(
													classesCSStyles?.accountSummarySubLabelOverdue,
													accountSummaryData?.morethan30days?.overdue
														? classesCSStyles?.redText
														: ""
												)}>
												{accountSummaryData?.morethan30days?.price}
											</div>
										</GridItem>
										<GridItem xs={12} sm={2} md={2}>
											<div className={classesCSStyles?.accountSummaryOverLabel}>
												More than 45 Days
											</div>
											<div
												className={classNames(
													classesCSStyles?.accountSummarySubLabelOverdue,
													accountSummaryData?.morethan45days?.overdue
														? classesCSStyles?.redText
														: ""
												)}>
												{accountSummaryData?.morethan45days?.price}
											</div>
										</GridItem>
										<GridItem xs={12} sm={2} md={2}>
											<div className={classesCSStyles?.accountSummaryOverLabel}>
												More than 60 Days
											</div>
											<div
												className={classNames(
													classesCSStyles?.accountSummarySubLabelOverdue,
													accountSummaryData?.morethan60days?.overdue
														? classesCSStyles?.redText
														: ""
												)}>
												{accountSummaryData?.morethan60days?.price}
											</div>
										</GridItem>
										<GridItem xs={12} sm={2} md={2}>
											<div className={classesCSStyles?.accountSummaryOverLabel}>
												More than 90 Days
											</div>
											<div
												className={classNames(
													classesCSStyles?.accountSummarySubLabelOverdue,
													accountSummaryData?.morethan90days?.overdue
														? classesCSStyles?.redText
														: ""
												)}>
												{accountSummaryData?.morethan90days?.price}
											</div>
										</GridItem>
									</GridContainer>
								</GridItem>
							</GridContainer>
						</>
					)}
				</CardBody>
			</Card>
		</div>
	);
}
